<proffeo-ui-dialog [title]="'project-locations.modals.add-multiple-location-modal-title' | translate">
  <div class="flex flex-col w-full h-full gap-2">
    <div class="flex w-full gap-2 flex-col">
      <proffeo-ui-input
        [formField]="form.name"
        label="project-locations.modals.main-part-of-name"
        placeholder="project-locations.modals.main-part-of-name-placeholder"
      />
    </div>
    <div class="flex w-full gap-2 flex-col">
      <proffeo-ui-input
        [formField]="form.amount"
        label="project-locations.modals.amount-of-locations"
        type="number"
      />
    </div>
    <div class="flex w-full gap-2 flex-col">
      <proffeo-ui-input
        [formField]="form.numbering"
        label="project-locations.modals.start-numbering-from"
        placeholder="project-locations.modals.start-numbering-from-placeholder"
        type="number"
      />
    </div>
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      text="close"
      matDialogClose
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="save()"
      [disabled]="form().invalid() || form().submitting()"
      variant="accent"
      text="save-and-close"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
